import styled, { css } from 'styled-components';
import { IconCircleCheck } from '@lmn/lastminute-react-icons/lastminute-icons-solid';
import { color, font } from "../../../themes/mixins/Fonts.js";
import { margin, padding, spacing } from "../../../themes/mixins/Spacings.js";
var DEFAULT_FORM_FIELD_HEIGHT = 52;
var labelTextShrunkCss = /*#__PURE__*/css(["transform:translateY(-21px) scale(0.75);"]);
var hiddenLabel = /*#__PURE__*/css(["display:none;"]);
var innerWrapperFocusedCss = /*#__PURE__*/css(["outline:0;box-shadow:0 0 0 1px ", ";"], color('gray800'));
var getLabelTextColor = function getLabelTextColor(_ref) {
  var $hasError = _ref.$hasError,
    $disabled = _ref.$disabled;
  if ($disabled) return color('gray200');
  if ($hasError) return color('danger500');
  return color('gray400');
};
var LabelText = /*#__PURE__*/styled.span.withConfig({
  displayName: "FormFieldstyles__LabelText",
  componentId: "sc-1pt5zgp-0"
})(["", ";color:", ";position:absolute;left:0;top:", "px;transform:translateY(-50%);transform-origin:top left;white-space:nowrap;transition:transform 200ms cubic-bezier(0,0,0.2,1) 0ms;user-select:none;min-width:80px;"], font('TextLarge'), getLabelTextColor, DEFAULT_FORM_FIELD_HEIGHT / 2);
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "FormFieldstyles__Wrapper",
  componentId: "sc-1pt5zgp-1"
})(["position:relative;flex-direction:column;box-sizing:border-box;align-items:stretch;", ""], function (_ref2) {
  var $isFullWidth = _ref2.$isFullWidth;
  return $isFullWidth ? css(["display:flex;width:100%;"]) : css(["display:inline-flex;min-width:25ch;"]);
});
var ExtraDescription = /*#__PURE__*/styled.span.withConfig({
  displayName: "FormFieldstyles__ExtraDescription",
  componentId: "sc-1pt5zgp-2"
})(["", " ", " color:", ";"], margin({
  left: 2,
  bottom: 0.5
}), font('TextNormal'), color('gray400'));
var InnerWrapper = /*#__PURE__*/styled.label.withConfig({
  displayName: "FormFieldstyles__InnerWrapper",
  componentId: "sc-1pt5zgp-3"
})(["", ";", ";background:", ";color:", ";display:flex;align-items:center;height:", "px;max-height:", "px;transition:box-shadow 0.1s ease-in-out;user-select:none;margin-bottom:0;box-shadow:", ";", ";", ""], padding({
  left: 2,
  right: 1
}), function (_ref3) {
  var theme = _ref3.theme;
  return theme.mixins.borderRadius('8px');
}, color('gray50'), color('gray800'), DEFAULT_FORM_FIELD_HEIGHT, DEFAULT_FORM_FIELD_HEIGHT, function (_ref4) {
  var $hasError = _ref4.$hasError;
  return $hasError ? css(["0 0 0 1px ", ""], color('danger500')) : '0 0 0 3px transparent';
}, function (_ref5) {
  var $hasError = _ref5.$hasError,
    $disabled = _ref5.$disabled;
  return !$hasError && !$disabled ? css(["&:hover{box-shadow:0 0 0 3px ", ";}&:focus-within{", "}"], color('gray200'), innerWrapperFocusedCss) : '';
}, function (_ref6) {
  var $placeholder = _ref6.$placeholder,
    $disabled = _ref6.$disabled;
  return !$disabled ? css(["&:focus-within{& ", "{", "}}"], LabelText, $placeholder ? hiddenLabel : labelTextShrunkCss) : '';
});
var ValueWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "FormFieldstyles__ValueWrapper",
  componentId: "sc-1pt5zgp-4"
})(["position:relative;display:inline-block;height:100%;width:calc(100% - ", ");margin-right:", ";overflow:hidden;"], spacing(1), spacing(1));
export var AdornmentWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "FormFieldstyles__AdornmentWrapper",
  componentId: "sc-1pt5zgp-5"
})(["", ";display:flex;align-items:center;justify-content:center;"], margin({
  right: 1
}));
var HelperText = /*#__PURE__*/styled.span.withConfig({
  displayName: "FormFieldstyles__HelperText",
  componentId: "sc-1pt5zgp-6"
})(["", ";color:", ";", ";word-break:break-word;"], font('TextSmall'), function (_ref7) {
  var $hasError = _ref7.$hasError;
  return $hasError ? color('danger500') : color('gray400');
}, margin({
  top: 0.5,
  left: 2,
  right: 1
}));
var GreenTickIcon = /*#__PURE__*/styled(IconCircleCheck).withConfig({
  displayName: "FormFieldstyles__GreenTickIcon",
  componentId: "sc-1pt5zgp-7"
})(["color:", ";"], color('success400'));
export var FormFieldStyles = {
  DEFAULT_FORM_FIELD_HEIGHT: DEFAULT_FORM_FIELD_HEIGHT,
  labelTextShrunkCss: labelTextShrunkCss,
  hiddenLabel: hiddenLabel,
  innerWrapperFocusedCss: innerWrapperFocusedCss,
  LabelText: LabelText,
  Wrapper: Wrapper,
  ExtraDescription: ExtraDescription,
  InnerWrapper: InnerWrapper,
  ValueWrapper: ValueWrapper,
  AdornmentWrapper: AdornmentWrapper,
  HelperText: HelperText,
  GreenTickIcon: GreenTickIcon
};